import { Socket, connect as io } from "socket.io-client";
import { Middleware } from 'redux'
import {
    chatCallBack,
    incomingChat,
    incomingChatRoom,
    connected,
    setScrollPosition,
    incomingQueueChatRoom,
    allowReceiveChat,
} from './chatSlice';
import { IIncomingRoom } from "./types";

const chatMiddleware: Middleware = store => {
    let socket: Socket;
    return next => action => {
        const { user } = store.getState().auth;
        const domain = process.env.REACT_APP_CHAT_SERVICE;
        const pathname = new URL(domain ?? "").pathname;
        const userName = user?.username;
        const deviceId = user?.deviceId;
        const tenantId = user?.tenantId;
        const roleName = user?.roleName;
        const type = action?.type?.split('/')[1];
        switch (type) {
            case "chatWSConnecting":
                if (domain && user?.deviceId) {
                    socket = io(domain, {
                        path: pathname == "/" ? undefined : pathname,
                        transports: ["websocket", "polling", "flashsocket"],
                    });
                    socket.on("chat-callback", (data: any) => {
                        store.dispatch(chatCallBack(data));
                    });
                    socket.on('incoming-chat-room', (data: IIncomingRoom[]) => {
                        const chatRoom = data.filter(a => a.agentUserName != undefined);
                        const queueChatRoom = data.filter(a => a.agentUserName == undefined);

                        store.dispatch(incomingChatRoom(chatRoom));
                        store.dispatch(incomingQueueChatRoom(queueChatRoom));
                    });
                    socket.on("incoming-message", (data: any) => {
                        store.dispatch(setScrollPosition("bottom"));
                        store.dispatch(incomingChat(data));
                    });
                    socket.on("connect", () => {
                        console.log('connected chat');
                        store.dispatch(connected(true));
                        const premitReceiveChat = roleName == "agent";
                        store.dispatch(allowReceiveChat(true))
                        socket.emit("join-room-agent", { deviceId, userName, tenantId, allowReceiveChat: premitReceiveChat });
                    });
                    socket.on("disconnect", () => {
                        console.log('disconnected chat');
                        store.dispatch(connected(false));
                    });
                }
                break;

            case "sendMessage":
                socket?.emit("chat", action.payload);
                break;
            case "resolveRoom":
                socket?.emit("resolve-chat", { roomId: action.payload.roomId, tenantId, sessionId: action.payload.sessionId });
                break;
            case "readMessage":
                socket?.emit("read-chat", { sessionId: action.payload.sessionId, messageId: action.payload.messageId });
                break;
            case "typingMessage":
                socket?.emit("typing-chat", { sessionId: action.payload.sessionId, userName: action.payload.userName });
                break;
            case "dequeueChat":
                socket?.emit("dequeue-chat", { sessionId: action.payload.sessionId, userName: action.payload.userName, tenantId });
                break;
            case "assignChat":
                socket?.emit("assign-chat", { sessions: action.payload.sessions, assignTo: action.payload.assignTo, tenantId });
                break;
            case "reassignChat":
                socket?.emit("reassign-chat", {
                    sessions: action.payload.sessions,
                    assignFrom: action.payload.assignFrom,
                    assignTo: action.payload.assignTo,
                    tenantId
                });
                break;
            case "chatWSDisconnecting":
                socket?.disconnect();
                break;

            case "chatWSOffline":
                store.dispatch(allowReceiveChat(false));
                socket?.emit("join-room-agent", { deviceId, userName, tenantId, allowReceiveChat: false });
                break;
        }
        next(action);

    }
}

export default chatMiddleware;
